import { Text } from './Text'

/**
 * Circular initials avatar — a gray-200-ringed circle showing the first letters
 * of the name's first and last words. Used in the home header now; reusable for
 * the profile surface later. No image variant yet (none in the design).
 *
 * Decorative by default: the header renders the full name next to it, so the
 * initials would otherwise be read out twice.
 */
function initialsOf(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean)
  if (words.length === 0) return ''
  const first = words[0][0] ?? ''
  const last = words.length > 1 ? (words[words.length - 1][0] ?? '') : ''
  return (first + last).toUpperCase()
}

export function Avatar({ name, className }: { name: string; className?: string }) {
  return (
    <span
      aria-hidden="true"
      className={`inline-flex shrink-0 items-center justify-center rounded-full border border-gray-200 bg-white text-gray-900 ${className ?? 'size-14'}`}
    >
      <Text variant="lg" weight="semibold">
        {initialsOf(name)}
      </Text>
    </span>
  )
}
